import { render, staticRenderFns } from "./DetailsCalification.vue?vue&type=template&id=d6890df2&"
import script from "./DetailsCalification.vue?vue&type=script&lang=ts&"
export * from "./DetailsCalification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports